import { LDFlagsService } from '../ld-flags.service';

export class ProfileLDFlags {
  constructor(private ldFlagsService: LDFlagsService) {}
}
